import '@angular/compiler';
import { PortalGsdcuserWidgetManualDriveComponent } from './portal.gsdcuser.widget.manual.drive/portal.gsdcuser.widget.manual.drive.component';
import { PortalDizestEditorImageComponent } from './portal.dizest.editor.image/portal.dizest.editor.image.component';
import { PortalGsdcuserManualComponent } from './portal.gsdcuser.manual/portal.gsdcuser.manual.component';
import { PortalGsdcadminNoticeItemComponent } from './portal.gsdcadmin.notice.item/portal.gsdcadmin.notice.item.component';
import { PortalDizestEditorWorkflowSidebarAiComponent } from './portal.dizest.editor.workflow.sidebar.ai/portal.dizest.editor.workflow.sidebar.ai.component';
import { PortalGsdcuserApproveGroupNewComponent } from './portal.gsdcuser.approve.group.new/portal.gsdcuser.approve.group.new.component';
import { PageStorageComponent } from './page.storage/page.storage.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PortalGsdcuserGroupItemComponent } from './portal.gsdcuser.group.item/portal.gsdcuser.group.item.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalDizestEditorWorkflowNodeComponent } from './portal.dizest.editor.workflow.node/portal.dizest.editor.workflow.node.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalGsdcadminCommunityGroupNewComponent } from './portal.gsdcadmin.community.group.new/portal.gsdcadmin.community.group.new.component';
import { PortalDizestDriveComponent } from './portal.dizest.drive/portal.dizest.drive.component';
import { PortalGsdcadminTicketingListComponent } from './portal.gsdcadmin.ticketing.list/portal.gsdcadmin.ticketing.list.component';
import { PortalGsdcuserTicketingListComponent } from './portal.gsdcuser.ticketing.list/portal.gsdcuser.ticketing.list.component';
import { PortalGsdcadminBoardItemComponent } from './portal.gsdcadmin.board.item/portal.gsdcadmin.board.item.component';
import { ComponentOperationLogsComponent } from './component.operation.logs/component.operation.logs.component';
import { PortalGsdcuserResearchItemComponent } from './portal.gsdcuser.research.item/portal.gsdcuser.research.item.component';
import { PortalGsdcadminCommunityNewComponent } from './portal.gsdcadmin.community.new/portal.gsdcadmin.community.new.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalGsdcuserFaqItemComponent } from './portal.gsdcuser.faq.item/portal.gsdcuser.faq.item.component';
import { PortalGsdcadminPasswordComponent } from './portal.gsdcadmin.password/portal.gsdcadmin.password.component';
import { ComponentAlertComponent } from './component.alert/component.alert.component';
import { PortalGsdcuserApproveSignupComponent } from './portal.gsdcuser.approve.signup/portal.gsdcuser.approve.signup.component';
import { PageReissueOtpComponent } from './page.reissue.otp/page.reissue.otp.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PortalGsdcadminNoticeListComponent } from './portal.gsdcadmin.notice.list/portal.gsdcadmin.notice.list.component';
import { PortalGsdcadminFaqListComponent } from './portal.gsdcadmin.faq.list/portal.gsdcadmin.faq.list.component';
import { PageFirstLoginComponent } from './page.first.login/page.first.login.component';
import { PortalGsdcadminUserListComponent } from './portal.gsdcadmin.user.list/portal.gsdcadmin.user.list.component';
import { PageNoticeComponent } from './page.notice/page.notice.component';
import { PortalGsdcadminResearchItemComponent } from './portal.gsdcadmin.research.item/portal.gsdcadmin.research.item.component';
import { PortalGsdcadminBoardListComponent } from './portal.gsdcadmin.board.list/portal.gsdcadmin.board.list.component';
import { PortalGsdcuserWidgetResearchGraphComponent } from './portal.gsdcuser.widget.research.graph/portal.gsdcuser.widget.research.graph.component';
import { PortalGsdcuserBoardListComponent } from './portal.gsdcuser.board.list/portal.gsdcuser.board.list.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalGsdcuserNoticeItemComponent } from './portal.gsdcuser.notice.item/portal.gsdcuser.notice.item.component';
import { PortalGsdcadminCommunityUsersComponent } from './portal.gsdcadmin.community.users/portal.gsdcadmin.community.users.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { PortalGsdcuserApproveGroupJoinComponent } from './portal.gsdcuser.approve.group.join/portal.gsdcuser.approve.group.join.component';
import { PortalDizestEditorWorkflowSidebarAppsComponent } from './portal.dizest.editor.workflow.sidebar.apps/portal.dizest.editor.workflow.sidebar.apps.component';
import { PortalGsdcadminWidgetUserAddComponent } from './portal.gsdcadmin.widget.user.add/portal.gsdcadmin.widget.user.add.component';
import { PageReissuePasswordComponent } from './page.reissue.password/page.reissue.password.component';
import { PortalGsdcadminFaqItemComponent } from './portal.gsdcadmin.faq.item/portal.gsdcadmin.faq.item.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalGsdcuserGroupRequestComponent } from './portal.gsdcuser.group.request/portal.gsdcuser.group.request.component';
import { PortalDizestEditorTerminalComponent } from './portal.dizest.editor.terminal/portal.dizest.editor.terminal.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PortalDizestEditorSettingComponent } from './portal.dizest.editor.setting/portal.dizest.editor.setting.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalGsdcuserTicketingNewComponent } from './portal.gsdcuser.ticketing.new/portal.gsdcuser.ticketing.new.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PageReissueBothComponent } from './page.reissue.both/page.reissue.both.component';
import { PortalGsdcuserNoticeListComponent } from './portal.gsdcuser.notice.list/portal.gsdcuser.notice.list.component';
import { PortalGsdcuserWidgetTicketingComponent } from './portal.gsdcuser.widget.ticketing/portal.gsdcuser.widget.ticketing.component';
import { PortalGsdcadminManualListComponent } from './portal.gsdcadmin.manual.list/portal.gsdcadmin.manual.list.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalGsdcuserGroupListComponent } from './portal.gsdcuser.group.list/portal.gsdcuser.group.list.component';
import { PortalDizestEditorWorkflowSidebarInfoComponent } from './portal.dizest.editor.workflow.sidebar.info/portal.dizest.editor.workflow.sidebar.info.component';
import { ComponentHeaderComponent } from './component.header/component.header.component';
import { PortalGsdcadminCommunityGroupInfoComponent } from './portal.gsdcadmin.community.group.info/portal.gsdcadmin.community.group.info.component';
import { PortalGsdcuserFaqItemsComponent } from './portal.gsdcuser.faq.items/portal.gsdcuser.faq.items.component';
import { PortalDizestEditorWorkflowSidebarApiComponent } from './portal.dizest.editor.workflow.sidebar.api/portal.dizest.editor.workflow.sidebar.api.component';
import { PortalGsdcadminWidgetManualDriveComponent } from './portal.gsdcadmin.widget.manual.drive/portal.gsdcadmin.widget.manual.drive.component';
import { PortalGsdcuserBoardItemComponent } from './portal.gsdcuser.board.item/portal.gsdcuser.board.item.component';
import { PortalGsdcadminCommunityInfoComponent } from './portal.gsdcadmin.community.info/portal.gsdcadmin.community.info.component';
import { ComponentCardComponent } from './component.card/component.card.component';
import { PortalGsdcuserTicketingItemComponent } from './portal.gsdcuser.ticketing.item/portal.gsdcuser.ticketing.item.component';
import { PortalGsdcadminManualImageComponent } from './portal.gsdcadmin.manual.image/portal.gsdcadmin.manual.image.component';
import { PortalGsdcadminCommunityListComponent } from './portal.gsdcadmin.community.list/portal.gsdcadmin.community.list.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageOtpIssuanceComponent } from './page.otp.issuance/page.otp.issuance.component';
import { PortalGsdcuserFaqListComponent } from './portal.gsdcuser.faq.list/portal.gsdcuser.faq.list.component';
import { PageSupportComponent } from './page.support/page.support.component';
import { PageAdminUserComponent } from './page.admin.user/page.admin.user.component';
import { ComponentGroupMailComponent } from './component.group.mail/component.group.mail.component';
import { PortalGsdcadminCommunityGroupComponent } from './portal.gsdcadmin.community.group/portal.gsdcadmin.community.group.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalGsdcuserWidgetResearchComponent } from './portal.gsdcuser.widget.research/portal.gsdcuser.widget.research.component';
import { PortalDizestEditorWorkflowComponent } from './portal.dizest.editor.workflow/portal.dizest.editor.workflow.component';
import { PageGroupComponent } from './page.group/page.group.component';
import { PageJoinComponent } from './page.join/page.join.component';
import { ComponentPaginationComponent } from './component.pagination/component.pagination.component';
import { PortalGsdcuserStorageComponent } from './portal.gsdcuser.storage/portal.gsdcuser.storage.component';
import { PageResearchComponent } from './page.research/page.research.component';
import { PortalGsdcuserApproveSignupWgroupComponent } from './portal.gsdcuser.approve.signup.wgroup/portal.gsdcuser.approve.signup.wgroup.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalGsdcuserResearchListComponent } from './portal.gsdcuser.research.list/portal.gsdcuser.research.list.component';
import { PortalGsdcuserBoardEditComponent } from './portal.gsdcuser.board.edit/portal.gsdcuser.board.edit.component';
import { PortalDizestEditorWorkflowSidebarPipComponent } from './portal.dizest.editor.workflow.sidebar.pip/portal.dizest.editor.workflow.sidebar.pip.component';
import { PortalDizestEditorHealthComponent } from './portal.dizest.editor.health/portal.dizest.editor.health.component';
import { PortalGsdcuserWidgetManualComponent } from './portal.gsdcuser.widget.manual/portal.gsdcuser.widget.manual.component';
import { PageResetPasswordComponent } from './page.reset.password/page.reset.password.component';
import { PortalDizestEditorVideoComponent } from './portal.dizest.editor.video/portal.dizest.editor.video.component';
import { PortalDizestEditorWorkflowSidebarCodeComponent } from './portal.dizest.editor.workflow.sidebar.code/portal.dizest.editor.workflow.sidebar.code.component';
import { PortalDizestEditorDefaultComponent } from './portal.dizest.editor.default/portal.dizest.editor.default.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalGsdcadminResearchListComponent } from './portal.gsdcadmin.research.list/portal.gsdcadmin.research.list.component';
import { ComponentAuthLanguageComponent } from './component.auth.language/component.auth.language.component';
import { PortalGsdcadminRequestComponent } from './portal.gsdcadmin.request/portal.gsdcadmin.request.component';
import { PortalGsdcadminTicketingItemComponent } from './portal.gsdcadmin.ticketing.item/portal.gsdcadmin.ticketing.item.component';
import { PortalGsdcuserWidgetBoardComponent } from './portal.gsdcuser.widget.board/portal.gsdcuser.widget.board.component';
import { PortalGsdcuserBoardInfoComponent } from './portal.gsdcuser.board.info/portal.gsdcuser.board.info.component';
import { PageBoardItemComponent } from './page.board.item/page.board.item.component';
import { PortalGsdcadminCommunityGroupUserComponent } from './portal.gsdcadmin.community.group.user/portal.gsdcadmin.community.group.user.component';
import { PortalGsdcuserWidgetNoticeComponent } from './portal.gsdcuser.widget.notice/portal.gsdcuser.widget.notice.component';
import { PortalGsdcadminCommunityItemComponent } from './portal.gsdcadmin.community.item/portal.gsdcadmin.community.item.component';
import { MatTreeModule } from '@angular/material/tree';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

@NgModule({
    declarations: [
        AppComponent,
        PortalGsdcuserWidgetManualDriveComponent,
        PortalDizestEditorImageComponent,
        PortalGsdcuserManualComponent,
        PortalGsdcadminNoticeItemComponent,
        PortalDizestEditorWorkflowSidebarAiComponent,
        PortalGsdcuserApproveGroupNewComponent,
        PageStorageComponent,
        ComponentNavAdminComponent,
        PortalGsdcuserGroupItemComponent,
        PortalSeasonUiDropdownComponent,
        PortalDizestEditorWorkflowNodeComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalGsdcadminCommunityGroupNewComponent,
        PortalDizestDriveComponent,
        PortalGsdcadminTicketingListComponent,
        PortalGsdcuserTicketingListComponent,
        PortalGsdcadminBoardItemComponent,
        ComponentOperationLogsComponent,
        PortalGsdcuserResearchItemComponent,
        PortalGsdcadminCommunityNewComponent,
        LayoutNavbarComponent,
        PortalGsdcuserFaqItemComponent,
        PortalGsdcadminPasswordComponent,
        ComponentAlertComponent,
        PortalGsdcuserApproveSignupComponent,
        PageReissueOtpComponent,
        PageDashboardComponent,
        PortalGsdcadminNoticeListComponent,
        PortalGsdcadminFaqListComponent,
        PageFirstLoginComponent,
        PortalGsdcadminUserListComponent,
        PageNoticeComponent,
        PortalGsdcadminResearchItemComponent,
        PortalGsdcadminBoardListComponent,
        PortalGsdcuserWidgetResearchGraphComponent,
        PortalGsdcuserBoardListComponent,
        PageAdminComponent,
        PortalGsdcuserNoticeItemComponent,
        PortalGsdcadminCommunityUsersComponent,
        LayoutUserComponent,
        PortalGsdcuserApproveGroupJoinComponent,
        PortalDizestEditorWorkflowSidebarAppsComponent,
        PortalGsdcadminWidgetUserAddComponent,
        PageReissuePasswordComponent,
        PortalGsdcadminFaqItemComponent,
        PageLoginComponent,
        PortalGsdcuserGroupRequestComponent,
        PortalDizestEditorTerminalComponent,
        PortalSeasonStatusbarComponent,
        LayoutAdminComponent,
        PortalDizestEditorSettingComponent,
        PortalSeasonLoadingHexaComponent,
        PortalSeasonPagenationComponent,
        PortalGsdcuserTicketingNewComponent,
        PortalSeasonLoadingComponent,
        PageReissueBothComponent,
        PortalGsdcuserNoticeListComponent,
        PortalGsdcuserWidgetTicketingComponent,
        PortalGsdcadminManualListComponent,
        ComponentNavUserComponent,
        LayoutEmptyComponent,
        PortalGsdcuserGroupListComponent,
        PortalDizestEditorWorkflowSidebarInfoComponent,
        ComponentHeaderComponent,
        PortalGsdcadminCommunityGroupInfoComponent,
        PortalGsdcuserFaqItemsComponent,
        PortalDizestEditorWorkflowSidebarApiComponent,
        PortalGsdcadminWidgetManualDriveComponent,
        PortalGsdcuserBoardItemComponent,
        PortalGsdcadminCommunityInfoComponent,
        ComponentCardComponent,
        PortalGsdcuserTicketingItemComponent,
        PortalGsdcadminManualImageComponent,
        PortalGsdcadminCommunityListComponent,
        PageMypageComponent,
        PageOtpIssuanceComponent,
        PortalGsdcuserFaqListComponent,
        PageSupportComponent,
        PageAdminUserComponent,
        ComponentGroupMailComponent,
        PortalGsdcadminCommunityGroupComponent,
        PortalSeasonViewerTreeComponent,
        PortalGsdcuserWidgetResearchComponent,
        PortalDizestEditorWorkflowComponent,
        PageGroupComponent,
        PageJoinComponent,
        ComponentPaginationComponent,
        PortalGsdcuserStorageComponent,
        PageResearchComponent,
        PortalGsdcuserApproveSignupWgroupComponent,
        PortalSeasonTabComponent,
        PortalGsdcuserResearchListComponent,
        PortalGsdcuserBoardEditComponent,
        PortalDizestEditorWorkflowSidebarPipComponent,
        PortalDizestEditorHealthComponent,
        PortalGsdcuserWidgetManualComponent,
        PageResetPasswordComponent,
        PortalDizestEditorVideoComponent,
        PortalDizestEditorWorkflowSidebarCodeComponent,
        PortalDizestEditorDefaultComponent,
        PortalSeasonAlertComponent,
        PortalGsdcadminResearchListComponent,
        ComponentAuthLanguageComponent,
        PortalGsdcadminRequestComponent,
        PortalGsdcadminTicketingItemComponent,
        PortalGsdcuserWidgetBoardComponent,
        PortalGsdcuserBoardInfoComponent,
        PageBoardItemComponent,
        PortalGsdcadminCommunityGroupUserComponent,
        PortalGsdcuserWidgetNoticeComponent,
        PortalGsdcadminCommunityItemComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
                MatTreeModule
    ],
    providers: [{
        provide: COMPOSITION_BUFFER_MODE,
        useValue: false
    }],
    bootstrap: [AppComponent]
})
export class AppModule { }